import { render, staticRenderFns } from "./back-button.vue?vue&type=template&id=0c96a6e3&lang=pug&"
import script from "./back-button.vue?vue&type=script&lang=js&"
export * from "./back-button.vue?vue&type=script&lang=js&"
import style0 from "./back-button.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports